import { pt, en } from "../Lang"
import { Validate } from '../api/api';

export const isAuthenticated = () => localStorage.getItem('Authorization') !== null;
export const getToken = () => localStorage.getItem('Authorization');
export const getLang = (lang) => lang ? lang : navigator.language;
export const getText = (lang) => {
  if (lang) {
    if (lang.toLowerCase() === "en-gb" || lang.toLowerCase() === "en" || lang.toLowerCase() === "engb") {
      return en();
    } else {
      return pt();
    }
  }

  if (getLang() === "en-GB" || getLang() === "en") {
    return en();
  } else {
    return pt();
  }
};
export const isValid = async () => {
  const valid = await Validate(getToken());
  if (!valid) {
    return false
  }
  return true
}
export const destroyToken = () => {
  localStorage.removeItem('Authorization');
  localStorage.removeItem('id');
  localStorage.removeItem('email');
  localStorage.removeItem('pass');
};
